import React, { useState } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useDispatch, useSelector } from "react-redux";
import { setCompetitionsTabStr } from "../../redux/slice/sliceHome";
import Covid19 from "../FooterMenuPages/Covid19";
import SwachhVidyalayaAbhiyanPage from "../SwachhVidyalayaAbhiyan/SwachhVidyalayaAbhiyanPage";
import SwachhVidyalayaComponent from "../SwachhVidyalayaAbhiyan/SwachhVidyalayaComponent";
import CovidComponent from "../FooterMenuPages/CovidComponent";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const ArchiveFooterPage = () => {
  const [activeTabs, setActiveTabs] = useState("swachh");
  const { amritTabStr } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink="/"
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
                <section className="leftmenu-hori">
                  <ul>
                    <li className={activeTabs === "swachh" ? "active" : ""}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTabs("swachh");
                        }}
                      >
                        <div className="icon icon-school"></div>
                        {getText(
                          "Swachh Vidyalaya Abhiyan",
                          "स्वच्छ विद्यालय अभियान"
                        )}
                      </a>
                    </li>

                    <li className={activeTabs === "covid-19" ? "active" : ""}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setActiveTabs("covid-19");
                        }}
                      >
                        <div className="icon icon-covid"></div>
                        {getText("Covid-19", "कोविड-19")}
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
            {/* <div className="mb-2">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
            </div> */}
            {activeTabs === "swachh" && <SwachhVidyalayaComponent />}
            {activeTabs === "covid-19" && <CovidComponent />}
          </div>
        </div>
      </div>
    </>
  );
};

export default ArchiveFooterPage;
